import { render, staticRenderFns } from "./SiteVersionDiffTree.vue?vue&type=template&id=9e4831b2&"
import script from "./SiteVersionDiffTree.vue?vue&type=script&lang=js&"
export * from "./SiteVersionDiffTree.vue?vue&type=script&lang=js&"
import style0 from "./SiteVersionDiffTree.vue?vue&type=style&index=0&id=9e4831b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports